import { parseDisappearAtMs } from '../../../Helpers/Chat/disappearTime';
import { ensureKeptIndex, selectKeepState } from '../../../slice/keptMessagesSlice';

/**
 * Drops the messages whose disappearing timer ran out, except the kept ones.
 *
 * A cached copy saved before the keep carries no keep state, so the server's keep list is
 * read first; if the server cannot answer, nothing past its timer is dropped.
 *
 * @param {Array} messages Messages about to be shown, newest state from cache or server.
 * @param {string} chatJid Conversation JID: the peer for 1-1, the group JID for a group.
 * @returns {Promise<Array>} The messages to keep showing.
 */
export const dropExpiredUnkept = (messages, chatJid) => async (dispatch, getState) => {
    const now = Date.now();
    const isPastTimer = message => parseDisappearAtMs(message.disappear_at || message.disappearAt) <= now;
    if (!messages.some(isPastTimer)) return messages;

    const isIndexNeeded = messages.some(message => isPastTimer(message) && !selectKeepState(getState(), message));
    const isIndexed = isIndexNeeded && (await dispatch(ensureKeptIndex(chatJid)));

    return messages.filter(message => {
        if (!isPastTimer(message)) return true;
        const keepState = selectKeepState(getState(), message);
        if (keepState) return keepState.isKept;
        // A complete keep list names every kept message; without one, keep on doubt.
        return !isIndexed;
    });
};
